"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const models_1 = require("@home-health-notify/models");
const MessagesMapper_1 = require("../mappers/MessagesMapper"); // Do not shorten this import as it creates a cyclic dependency
const models_2 = require("../models");
const roleAccess_1 = require("../roleAccess/roleAccess");
const Observable_1 = require("../socket/Observable");
const utils_1 = require("../utils");
const DomainEvents_1 = require("../utils/DomainEvents");
const IMessage_1 = require("./IMessage");
const MessageUtil_1 = require("./MessageUtil");
const UnStarException_1 = require("../chat/exceptions/UnStarException");
const StarException_1 = require("../chat/exceptions/StarException");
class Message {
    constructor(message, socketAdapter, httpAdapter, userDirectory, orgUser, chatContext, changeListener) {
        this.messageData = message;
        this.chatContext = chatContext;
        this.socketAdapter = socketAdapter;
        this.httpAdapter = httpAdapter;
        this.userDirectory = userDirectory;
        this.orgUser = orgUser;
        this.changeListener = changeListener;
        if (changeListener) {
            this.unstarMessageListener(changeListener);
        }
    }
    markAsRead() {
        if (!this.chatContext) {
            throw new Error("Panic: message chat context is empty!!!");
        }
        this.chatContext.markMessageAsRead(this);
    }
    revokeReferral(userId, groupId) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            if (!this.chatContext) {
                throw new Error("Panic: message chat context is empty!!!");
            }
            yield ((_a = this.chatContext) === null || _a === void 0 ? void 0 : _a.revokeReferral(userId, groupId));
        });
    }
    resendAsPriority() {
        if (!this.chatContext) {
            throw new Error("Panic: message chat context is empty!!!");
        }
        this.chatContext.resendAsPriorityMessage(this);
    }
    resend() {
        if (!this.chatContext) {
            throw new Error("Panic: message chat context is empty!!!");
        }
        this.chatContext.resendMessage(this);
    }
    canRetrySend() {
        var _a, _b;
        return (_b = (_a = this.chatContext) === null || _a === void 0 ? void 0 : _a.canRetryMessage(this)) !== null && _b !== void 0 ? _b : false;
    }
    retrySend() {
        var _a;
        (_a = this.chatContext) === null || _a === void 0 ? void 0 : _a.retryFailedMessage(this);
    }
    canRetryEdit() {
        var _a, _b;
        return (_b = (_a = this.chatContext) === null || _a === void 0 ? void 0 : _a.canRetryEdit(this)) !== null && _b !== void 0 ? _b : false;
    }
    retryEdit() {
        var _a;
        (_a = this.chatContext) === null || _a === void 0 ? void 0 : _a.retryFailedEdit(this);
    }
    getContextMenu() {
        if (!this.chatContext) {
            throw new Error("Panic: message chat context is empty!!!");
        }
        if (this.isDeleted()) {
            return [];
        }
        return this.chatContext
            .getContextMenu()
            .filter(menuItem => this.filterContextMenu(menuItem));
    }
    filterContextMenu(menuItem) {
        const { type, contentType, isSender, chatType, status, isVisibleToPatient, isVisibleToPhysician, } = this.messageData;
        const isGroupChat = chatType === models_2.CHAT_TYPE.GROUP;
        const isMessageTypePriority = type === models_2.MESSAGE_TYPE.PRIORITY;
        const isMessageContentTypeText = contentType === models_2.MESSAGE_CONTENT_TYPE.TEXT;
        const isMessageContentTypeLink = contentType === models_2.MESSAGE_CONTENT_TYPE.LINK;
        const isMessageContentTypeForm = contentType === models_2.MESSAGE_CONTENT_TYPE.FORM;
        const isMessageContentTypeReminder = contentType === models_2.MESSAGE_CONTENT_TYPE.REMINDER;
        const isMessageStatusDeleted = status === models_2.MESSAGE_STATUS.DELETED;
        const messageAge = Date.now() - this.messageData.createdAt;
        const isWithinEditTimeLimit = messageAge >= 0 && messageAge <= utils_1.HHNConstants.MESSAGE_EDIT_TIME_LIMIT_MS;
        switch (menuItem) {
            case IMessage_1.MESSAGE_CONTEXT_MENU.INFO:
                return true;
            case IMessage_1.MESSAGE_CONTEXT_MENU.STAR_MESSAGE:
                return !this.isStarred() && !this.isBroadcastMessage();
            case IMessage_1.MESSAGE_CONTEXT_MENU.UNSTAR_MESSAGE:
                return this.isStarred() && !this.isBroadcastMessage();
            case IMessage_1.MESSAGE_CONTEXT_MENU.REPLY:
                return !this.isReminder();
            case IMessage_1.MESSAGE_CONTEXT_MENU.ASK_ACKNOWLEDGEMENT:
                return (isSender &&
                    isGroupChat &&
                    !isMessageContentTypeReminder &&
                    !isMessageTypePriority);
            case IMessage_1.MESSAGE_CONTEXT_MENU.DELETE_MESSAGE:
                return isSender && !isMessageStatusDeleted;
            case IMessage_1.MESSAGE_CONTEXT_MENU.COPY:
                return (isMessageContentTypeText ||
                    isMessageContentTypeLink ||
                    isMessageContentTypeForm);
            case IMessage_1.MESSAGE_CONTEXT_MENU.EDIT:
                return (isSender &&
                    (isMessageContentTypeText || isMessageContentTypeLink) &&
                    isWithinEditTimeLimit);
            case IMessage_1.MESSAGE_CONTEXT_MENU.RESEND:
                return isSender && !isMessageContentTypeReminder;
            case IMessage_1.MESSAGE_CONTEXT_MENU.RESEND_AS_PRIORITY:
                return isSender && !isMessageContentTypeReminder;
            case IMessage_1.MESSAGE_CONTEXT_MENU.VISIBLE_TO_PATIENT:
                return isSender && !isVisibleToPatient;
            case IMessage_1.MESSAGE_CONTEXT_MENU.VISIBLE_TO_PHYSICIAN:
                return isSender && !isVisibleToPhysician;
            case IMessage_1.MESSAGE_CONTEXT_MENU.FORWARD_MESSAGE:
                return this.canForward();
            default:
                return true;
        }
    }
    isVisibleToPatientAndPhysician() {
        return this.isVisibleToPatient() && this.isVisibleToPhysician();
    }
    isStarred() {
        return this.messageData.isStarred;
    }
    isDeleted() {
        return this.messageData.status === models_2.MESSAGE_STATUS.DELETED;
    }
    isEdited() {
        var _a;
        return (_a = this.messageData.isEdited) !== null && _a !== void 0 ? _a : false;
    }
    isReminder() {
        return this.messageData.contentType === models_2.MESSAGE_CONTENT_TYPE.REMINDER;
    }
    isInfoMessage() {
        return this.messageData.type === models_2.MESSAGE_TYPE.INFO;
    }
    isBroadcastMessage() {
        return this.messageData.chatType === models_2.CHAT_TYPE.BROADCAST;
    }
    isSmartContentMessage() {
        return this.messageData.contentType === models_2.MESSAGE_CONTENT_TYPE.SMART;
    }
    isVisibleIfDeleted() {
        return this.orgUser.hasAccess(roleAccess_1.FEATURES.VIEW_DELETED_MESSAGES);
    }
    canForward() {
        return !this.isDeleted() && !this.isReminder() && !this.isInfoMessage();
    }
    isVisibleToPhysician() {
        return this.messageData.isVisibleToPhysician || false;
    }
    isVisibleToPatientOrPhysician() {
        return (this.messageData.isVisibleToPatient ||
            this.messageData.isVisibleToPhysician ||
            false);
    }
    isVisibleToPatient() {
        return this.messageData.isVisibleToPatient || false;
    }
    getMessage() {
        return this.messageData;
    }
    acknowledge() {
        const payload = {
            to: this.messageData.chatId,
            user: this.messageData.from,
            _id: this.messageData.id,
        };
        this.socketAdapter.sendAcknowledgment(payload);
    }
    deleteMessage() {
        const payload = {
            to: this.messageData.chatId,
            user: this.messageData.from,
            _id: this.messageData.id,
        };
        this.socketAdapter.deleteMessage(payload);
    }
    /**
     * Fetches recipient list filtered on below:
     * - If visibleTo.id is not a sender himself.
     */
    fetchRecipientInfo() {
        return __awaiter(this, void 0, void 0, function* () {
            // Coalesce concurrent callers onto one in-flight request, else two screens
            // mounting against the same Message race and DuplicateRequestInterceptor
            // rejects the second identical GET.
            if (this.recipientInfoFetchPromise) {
                return this.recipientInfoFetchPromise;
            }
            this.recipientInfoFetchPromise = this.fetchRecipientInfoInternal().finally(() => {
                this.recipientInfoFetchPromise = undefined;
            });
            return this.recipientInfoFetchPromise;
        });
    }
    fetchRecipientInfoInternal() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const recipientInfoResponse = yield this.httpAdapter
                .getMessageAdapter()
                .fetchRecipientInfo(this.messageData.id);
            const mappedRecipientInfo = (0, MessagesMapper_1.recipientInfoMapper)(recipientInfoResponse, this.userDirectory);
            this.messageData.recipientInfo = Object.assign(Object.assign({}, mappedRecipientInfo), { visibleTo: (_a = mappedRecipientInfo.visibleTo) === null || _a === void 0 ? void 0 : _a.filter(visibleTo => this.messageData.from !== visibleTo.id) });
        });
    }
    getPreviewDataFromMessage() {
        return (0, MessagesMapper_1.mapMessageToPreviewData)(this.messageData);
    }
    actionOnReferralReminder(data, responseCallback) {
        // eslint-disable-next-line no-useless-catch
        try {
            if (!this.orgUser.hasAccess(roleAccess_1.FEATURES.SEND_REFERRALS)) {
                throw new Error(utils_1.ErrorMessages.noAccessFound);
            }
            const newData = {
                _id: this.messageData.id,
                action: data.action,
                scheduleTime: data.scheduleTime,
            };
            this.socketAdapter.actionOnReminder(newData, responseCallback);
        }
        catch (e) {
            throw e;
        }
    }
    starMessage() {
        return __awaiter(this, void 0, void 0, function* () {
            // eslint-disable-next-line no-useless-catch
            try {
                const data = yield this.httpAdapter
                    .getMessageAdapter()
                    .setMessageStar((0, MessageUtil_1.getStarMessageRequestData)(models_1.STAR_MESSAGE_ACTIONS.MARK, this.messageData));
                Observable_1.Observable.getInstance().notify((0, DomainEvents_1.getEventKey)(DomainEvents_1.DomainEvents.STAR_MESSAGE, this.orgUser.getOrganizationId()), this);
                if (!data) {
                    throw new StarException_1.StarException();
                }
            }
            catch (e) {
                throw e;
            }
        });
    }
    removeStarredMessage() {
        return __awaiter(this, void 0, void 0, function* () {
            // eslint-disable-next-line no-useless-catch
            try {
                const newMessageData = Object.assign({}, this.messageData);
                if (newMessageData.visibleTo) {
                    const selfUserIndex = newMessageData.visibleTo.findIndex(visibleTo => visibleTo.id === this.orgUser.getOrganization().userProfile.id);
                    if (selfUserIndex && selfUserIndex >= 0) {
                        newMessageData.visibleTo[selfUserIndex].haveStarMarked = 0;
                    }
                }
                this.messageData = newMessageData;
                Observable_1.Observable.getInstance().notify((0, DomainEvents_1.getEventKey)(DomainEvents_1.DomainEvents.UNSTAR_MESSAGE, this.orgUser.getOrganizationId()), this);
                Observable_1.Observable.getInstance().notify((0, DomainEvents_1.getEventKey)(DomainEvents_1.DomainEvents.UNSTAR_SINGLE_MESSAGE, this.messageData.id), this);
                const data = yield this.httpAdapter
                    .getMessageAdapter()
                    .setMessageStar((0, MessageUtil_1.getStarMessageRequestData)(models_1.STAR_MESSAGE_ACTIONS.UNMARK, this.messageData));
                if (data !== null) {
                    throw new UnStarException_1.UnStarException();
                }
            }
            catch (e) {
                throw e;
            }
        });
    }
    unstarMessageListener(cb) {
        return Observable_1.Observable.getInstance().subscribe((0, DomainEvents_1.getEventKey)(DomainEvents_1.DomainEvents.UNSTAR_SINGLE_MESSAGE, this.messageData.id), (message) => {
            this.messageData = message.getMessage();
            cb(this);
        });
    }
    askForAcknowledgement(body) {
        const payload = {
            add: body.usersToAcknowledge,
            _id: this.messageData.id,
        };
        this.socketAdapter.askAcknowledgment(payload);
    }
    markMessageVisibleToPatient() {
        this.setVisibilityTo(models_2.USER_TYPE.PATIENT);
    }
    markMessageVisibleToPhysician() {
        this.setVisibilityTo(models_2.USER_TYPE.PHYSICIAN);
    }
    setVisibilityTo(userType) {
        const data = {
            to: this.messageData.chatId,
            _id: this.messageData.id,
            visibleTo: [userType],
        };
        this.socketAdapter.markPatientAsVisible(data);
    }
    updateMessageStatus(messageStatus) {
        var _a;
        this.messageData.status = messageStatus;
        (_a = this.changeListener) === null || _a === void 0 ? void 0 : _a.call(this, this);
    }
    containsMedia() {
        return (this.messageData.contentType === models_2.MESSAGE_CONTENT_TYPE.IMAGE ||
            this.messageData.contentType === models_2.MESSAGE_CONTENT_TYPE.VIDEO ||
            this.messageData.contentType === models_2.MESSAGE_CONTENT_TYPE.VOICE);
    }
}
exports.default = Message;
